export interface LogContext {
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  [key: string]: any;
}

export abstract class Logger {
  public debug: (msg: string, context?: LogContext) => void;
  public error: (msg: string, context?: LogContext) => void;
  public info: (msg: string, context?: LogContext) => void;
  public warn: (msg: string, context?: LogContext) => void;
}
